import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { ModuleNames } from 'projects/Autofacets-Core/src/app/utils/enums';
import { BehaviorSubject, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { ActionTypeService } from '../../business-services/action-type.service';

@Component({
  selector: 'app-action-type',
  templateUrl: './action-type.component.html'

})
export class ActionTypeComponent implements OnInit, OnDestroy {
  //#region Declaration
  lstActionType: any[] = [];
  paginationSub: Subscription;
  canEdit: boolean = false;

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  //#endregion

  //#region Constructor & Implements
  constructor(
    public pService: CustomPaggerService,
    public spinner: NgxSpinnerService,
    public router: Router,
    private toaster: ToastrService,
    private translate: TranslateService,
    private actionTypeService: ActionTypeService,
    private userDataService: UserDataService
  ) {
    this.pService.pageSize = 20;
    this.pService.searchby = ['actionName'];
    this.pService.searchTerm = '';
  }

  ngOnInit(): void {
    this.GetActionTypeList();
    this.userDataService.currentUserSubject.subscribe((res) => {
      this.canEdit = res.userRoleMenuDetails?.find(x => x.moduleId == ModuleNames.ActionType)?.canEdit;
    })
    this.paginationSub = this.pService.dealers$.subscribe((actions: any[]) => {
      this.lstActionType = actions.map((act, index) => ({ ...act, row: this.currentPageNumber(index) }))
    });
  }
  ngOnDestroy() {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.pService.total$ = new BehaviorSubject<number>(0);
  }
  //#endregion

  //#region Page Methods
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }
    return rtPageNumber;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }
  onRefresh(){
    this.GetActionTypeList();
  }
  //#endregion

  //#region API Methods
  GetActionTypeList() {
    this.spinner.show();
    this.actionTypeService.GetList().then((res) => {
      if (res.responseCode === 200) {
        this.lstActionType = res.responseObject.map((act, index) => ({ ...act, row: this.currentPageNumber(index) }));
        this.pService.dataSource = this.lstActionType;
      }
    })
    this.spinner.hide();
  }
  onSaveChanges() {
    this.spinner.show();
    this.actionTypeService.Update(this.lstActionType).then((res) => {
      if (res.responseObject === true) {
        this.GetActionTypeList();
        let successMsg = this.translate.instant("lblActionConfigUpdated");
        this.toaster.success(successMsg);
      }
      else {
        let errorMsg = this.translate.instant("lblActionConfigNotUpdated");
        this.toaster.error(errorMsg);
      }
    }).finally(() => {
      this.spinner.hide();
    })
  }
  //#endregion

}
